import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 z-20" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "my-4" }
const _hoisted_6 = { class: "p-6 rounded-xl border border-gray-lp-1300 flex flex-col" }
const _hoisted_7 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M9 12C9 12.55 9.45 13 10 13H14C14.55 13 15 12.55 15 12C15 11.45 14.55 11 14 11H10C9.45 11 9 11.45 9 12Z",
    fill: "#A7A8AA"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.0002 3H7.00018C6.69018 3 6.39019 3.15 6.20019 3.4L3.20019 7.4C3.19368 7.40918 3.18733 7.41843 3.18113 7.42776C3.06709 7.59016 3 7.78763 3 8V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V8C21 7.93796 20.9943 7.8772 20.9833 7.81821C20.9568 7.66842 20.8958 7.52471 20.8002 7.4L17.8002 3.4C17.6102 3.15 17.3102 3 17.0002 3ZM18.0002 7L16.5002 5H13V7H18.0002ZM11 7V5H7.50018L6.00018 7H11ZM5 9H19V19H5V9Z",
    fill: "#A7A8AA"
  })
], -1)
const _hoisted_9 = { class: "flex mt-4 flex-col" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_12 = { class: "flex flex-row mt-4" }
const _hoisted_13 = { class: "w-full mr-2" }
const _hoisted_14 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_15 = { class: "text-14px xxl:text-14px" }
const _hoisted_16 = { class: "ml-1 relative" }
const _hoisted_17 = { class: "w-full ml-2" }
const _hoisted_18 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_19 = { class: "text-14px xxl:text-14px" }
const _hoisted_20 = { class: "ml-1 relative" }
const _hoisted_21 = {
  key: 0,
  class: "text-red-lp-100 text-14px xxl:text-14px flex pl-1 gap-x-2"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "warning"
}, null, -1)
const _hoisted_23 = { class: "flex flex-row mt-4" }
const _hoisted_24 = {
  key: 0,
  class: "w-full mr-2"
}
const _hoisted_25 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_26 = { class: "ml-1 relative" }
const _hoisted_27 = {
  key: 1,
  class: "w-full ml-2"
}
const _hoisted_28 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, "Komoditas Selanjutnya", -1)
const _hoisted_30 = { class: "ml-1 relative" }
const _hoisted_31 = {
  key: 1,
  class: "mb-8 mt-4"
}
const _hoisted_32 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "\n                w-full\n              " }
const _hoisted_36 = { class: "flex w-full flex-row gap-x-6 pt-6" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 font-semibold text-12px xxl:text-14px text-center text-gray-lp-300" }, " No ", -1)
const _hoisted_38 = { class: "w-40 font-semibold text-12px xxl:text-14px flex flex-row text-gray-lp-300" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (kg)", -1)
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = { class: "w-4/12 font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_42 = { class: "font-normal text-gray-lp-500" }
const _hoisted_43 = { class: "w-36 font-semibold text-14p text-center text-gray-lp-300" }
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "border-t mt-4" }, null, -1)
const _hoisted_46 = { class: "flex flex-row items-center gap-x-6" }
const _hoisted_47 = { class: "w-1/12 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_48 = { class: "w-40" }
const _hoisted_49 = { class: "w-4/12 bg-white" }
const _hoisted_50 = { class: "w-36 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_51 = {
  key: 0,
  class: "w-20"
}
const _hoisted_52 = {
  key: 0,
  class: "flex flex-row pl-5 pt-1"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_55 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_56 = {
  key: 0,
  class: "flex flex-row justify-start gap-x-6 mb-6`"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_58 = { class: "flex flex-row px-4 pt-2 pb-3 rounded-md mt-4 w-max bg-warning-hws" }
const _hoisted_59 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 text-12px" }, null, -1)
const _hoisted_60 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 pt-2 pb-4"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 1,
  class: "flex flex-row justify-between text-12px xxl:text-14px px-6 my-6"
}
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Tambah Barang ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Tambah Barang ")
const _hoisted_67 = { class: "" }
const _hoisted_68 = {
  key: 2,
  class: "w-10/12"
}
const _hoisted_69 = { class: "text-14px pt-5 text-black-lp-300 font-bold" }
const _hoisted_70 = { class: "flex items-center justify-center py-3" }
const _hoisted_71 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_72 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SectionSTTManualReference = _resolveComponent("SectionSTTManualReference")!
  const _component_SectionSenderDetail = _resolveComponent("SectionSenderDetail")!
  const _component_SectionRecipientDetail = _resolveComponent("SectionRecipientDetail")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Woodpacking = _resolveComponent("Woodpacking")!
  const _component_SectionPackageDetail = _resolveComponent("SectionPackageDetail")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SectionAdditionalInfoInterpack = _resolveComponent("SectionAdditionalInfoInterpack")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SectionUploadPhotoForWeightAdjustment = _resolveComponent("SectionUploadPhotoForWeightAdjustment")!
  const _component_BannerProductType = _resolveComponent("BannerProductType")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SectionFooterBooking = _resolveComponent("SectionFooterBooking")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_card = _resolveComponent("card")!
  const _component_ModalErrorNotAllowEdit = _resolveComponent("ModalErrorNotAllowEdit")!

  return (_ctx.isLoadingDetail)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, { key: 0 }))
    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "w-5 mr-3 cursor-pointer",
              alt: "back"
            }),
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1)
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorDetail,
              onTryAgain: _ctx.getDetail
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", {
              class: "flex flex-col px-4 text-12px xxl:text-14px gap-y-4 overflow-y-auto pb-20 mt-6 w-10/12",
              key: _ctx.reRenderManualBooking
            }, [
              _createVNode("div", null, [
                _createVNode(_component_SectionSTTManualReference, {
                  ref: "sttManualReference",
                  modelValue: _ctx.manualBooking,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.manualBooking = $event)),
                  error: _ctx.error,
                  "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_ctx.error = $event)),
                  formType: _ctx.formType,
                  disabledRefExt: true,
                  isSttRetail: _ctx.isSttRetail,
                  checkoutPaymentMethod: _ctx.checkoutPaymentMethod,
                  isSttForeign: _ctx.isSttForeign
                }, null, 8, ["modelValue", "error", "formType", "isSttRetail", "checkoutPaymentMethod", "isSttForeign"]),
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_SectionSenderDetail, {
                    ref: "senderDetail",
                    modelValue: _ctx.manualBooking,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualBooking = $event)),
                    error: _ctx.error,
                    "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => (_ctx.error = $event)),
                    accountIsNonForeign: !_ctx.isSttForeign,
                    disableSaveSender: _ctx.disableSaveSender,
                    isDisableDeliverySender: _ctx.isDisableDeliverySender,
                    existCustomerSender: _ctx.existCustomerSender.existSender,
                    isDisabledCommodity: _ctx.isDisabledCommodity,
                    "disabled-phone": _ctx.isPhoneSenderNonEditable,
                    onCheckFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.focusedText = true)),
                    onAutofillCommodity: _ctx.autofillCommodity,
                    onAutofillCommodityNotFound: _ctx.autofillCommodityNotFound
                  }, null, 8, ["modelValue", "error", "accountIsNonForeign", "disableSaveSender", "isDisableDeliverySender", "existCustomerSender", "isDisabledCommodity", "disabled-phone", "onAutofillCommodity", "onAutofillCommodityNotFound"])
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_SectionRecipientDetail, {
                    ref: "recipientDetail",
                    modelValue: _ctx.manualBooking,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.manualBooking = $event)),
                    error: _ctx.error,
                    accountIsNonForeign: !_ctx.isSttForeign,
                    listKGs: _ctx.listKGs,
                    disableSaveReceiver: _ctx.disableSaveReceiver,
                    postalCodeDestinationOptions: _ctx.postalCodeDestinationOptions,
                    isDisableDeliveryReceiver: _ctx.isDisableDeliveryReceiver,
                    onOnSearchZipCode: _ctx.setPostalCode,
                    onOnChangeDistrict: _ctx.setDestination,
                    existCustomerReceiver: _ctx.existCustomerReceiver.existReceiver,
                    errorMessageDestinationCity: "",
                    deliveryFeeType: _ctx.deliveryFeeType,
                    onOnSelectAddressType: _ctx.onSelectAddressType,
                    onOnFocusedText: _cache[8] || (_cache[8] = ($event: any) => (_ctx.focusedText = true)),
                    onCheckFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.focusedText = true)),
                    form: _ctx.manualBooking,
                    "disabled-phone": _ctx.isPhoneRecipientNonEditable
                  }, null, 8, ["modelValue", "error", "accountIsNonForeign", "listKGs", "disableSaveReceiver", "postalCodeDestinationOptions", "isDisableDeliveryReceiver", "onOnSearchZipCode", "onOnChangeDistrict", "existCustomerReceiver", "deliveryFeeType", "onOnSelectAddressType", "form", "disabled-phone"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_Title, {
                      fontColor: "text-black",
                      fontSize: 20,
                      label: "Detail Barang & Jenis Pengiriman"
                    })
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_SectionPackageDetail, {
                      ref: "packageDetail",
                      modelValue: _ctx.manualBooking,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.manualBooking = $event)),
                      error: _ctx.error,
                      deliveryFeeType: _ctx.deliveryFeeType,
                      errorEmbargo: _ctx.errorEmbargo,
                      errorEstimationPrice: _ctx.errorEstimationPrice,
                      "onUpdate:errorEstimationPrice": _cache[12] || (_cache[12] = ($event: any) => (_ctx.errorEstimationPrice = $event)),
                      formType: _ctx.formType,
                      onOnChangeCommodities: _ctx.onChangeCommodities,
                      isDisabledCommodity: _ctx.isDisabledCommodity,
                      isCodAmount: _ctx.showCodSection,
                      onCheckFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.focusedText = true)),
                      showGoodsCategory: _ctx.enabledCommodityT1B1B2TKP01,
                      goodsNames: _ctx.manualBooking.goodsNames,
                      estimationPrice: _ctx.manualBooking.sttGoodsEstimatePrice,
                      isShowBanner: false
                    }, {
                      woodpacking: _withCtx(() => [
                        _createVNode(_component_Woodpacking, {
                          ref: "woodpacking",
                          modelValue: _ctx.manualBooking.sttIsWoodPacking,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.manualBooking.sttIsWoodPacking = $event)),
                          city: _ctx.manualBooking.sttOriginCityId,
                          isDisabled: 
                    _ctx.manualBooking.sttIsWoodPackingKeeped ||
                      (_ctx.isBookingShipment &&
                        (_ctx.manualBooking.sttLastStatus === 'BKD' ||
                          _ctx.manualBooking.sttLastStatus === 'STT ADJUSTED'))
                  ,
                          eligibleAccess: _ctx.eligibleToWoodpacking,
                          eligibleAccessForShipment: _ctx.woodpackingForshipment,
                          version: "v2",
                          onSetFocus: _ctx.checkFocus
                        }, null, 8, ["modelValue", "city", "isDisabled", "eligibleAccess", "eligibleAccessForShipment", "onSetFocus"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error", "deliveryFeeType", "errorEmbargo", "errorEstimationPrice", "formType", "onOnChangeCommodities", "isDisabledCommodity", "isCodAmount", "showGoodsCategory", "goodsNames", "estimationPrice"])
                  ]),
                  (_ctx.isFtzAccount)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_Title, {
                          fontSize: 16,
                          label: _ctx.$t('bookingShipment.column.crossBorderInformation'),
                          fontColor: "text-gray-lp-300",
                          hint: _ctx.accountIsForeign ? '' : '(Khusus area BATAM)'
                        }, null, 8, ["label", "hint"]),
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("bookingShipment.column.taxIdentificationNumber")), 1),
                              _createVNode("div", _hoisted_16, [
                                _createVNode("img", {
                                  onMouseenter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOpenTooltipTax = true)),
                                  onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isOpenTooltipTax = false)),
                                  src: 
                        _ctx.isOpenTooltipTax
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      ,
                                  alt: ""
                                }, null, 40, ["src"]),
                                _withDirectives(_createVNode(_component_Tooltip, {
                                  title: _ctx.$t('bookingShipment.tooltip.tax'),
                                  message: _ctx.$t('bookingShipment.tooltip.taxMsg'),
                                  footer: "",
                                  class: "w-200px ml-8",
                                  style: {"margin-top":"-2.8em"}
                                }, null, 8, ["title", "message"]), [
                                  [_vShow, _ctx.isOpenTooltipTax]
                                ])
                              ])
                            ]),
                            (!_ctx.isSttForeign)
                              ? (_openBlock(), _createBlock(_component_lp_input, {
                                  key: 0,
                                  modelValue: _ctx.manualBooking.sttTaxNumber,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.manualBooking.sttTaxNumber = $event)),
                                  format: _ctx.formatted,
                                  onChange: _ctx.validateTaxNumber,
                                  errorCaption: "Masukan No. NPWP dengan benar",
                                  error: _ctx.error.taxNumber,
                                  placeholder: 
                    _ctx.$t('bookingShipment.placeholder.taxIdentificationNumber')
                  ,
                                  maxLength: "20",
                                  disabled: _ctx.isDisableTax,
                                  disableBackground: _ctx.isDisableTax,
                                  "show-max-length": ""
                                }, null, 8, ["modelValue", "format", "onChange", "error", "placeholder", "disabled", "disableBackground"]))
                              : (_openBlock(), _createBlock(_component_lp_input, {
                                  key: 1,
                                  modelValue: _ctx.manualBooking.sttTaxNumber,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.manualBooking.sttTaxNumber = $event)),
                                  placeholder: 
                    _ctx.$t('bookingShipment.placeholder.taxIdentificationNumber')
                  ,
                                  maxLength: 20,
                                  "show-max-length": "",
                                  disabled: _ctx.isDisableTax,
                                  disableBackground: _ctx.isDisableTax,
                                  onChange: _ctx.checkFocus
                                }, null, 8, ["modelValue", "placeholder", "disabled", "disableBackground", "onChange"]))
                          ]),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("div", _hoisted_18, [
                              _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("bookingShipment.column.shipmentStatus")), 1),
                              _createVNode("div", _hoisted_20, [
                                _createVNode("img", {
                                  onMouseenter: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = true)),
                                  onMouseleave: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = false)),
                                  src: 
                        _ctx.isOpenTooltipStatusGoods
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      ,
                                  alt: ""
                                }, null, 40, ["src"]),
                                _withDirectives(_createVNode(_component_Tooltip, {
                                  title: _ctx.$t('bookingShipment.tooltip.shipmentStatus'),
                                  message: _ctx.$t('bookingShipment.tooltip.shipmentStatusMsg'),
                                  footer: "",
                                  style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                                }, null, 8, ["title", "message"]), [
                                  [_vShow, _ctx.isOpenTooltipStatusGoods]
                                ])
                              ])
                            ]),
                            _createVNode(_component_Select, {
                              onOpenSelect: 
                    () => {
                      _ctx.checkFocus();
                      _ctx.onOpenSelect();
                      _ctx.setFieldIndex(12);
                    }
                  ,
                              onCloseSelect: _ctx.onCloseSelect,
                              isOpenMenu: _ctx.isStatusGoods,
                              value: _ctx.manualBooking.sttSenderStatus,
                              onChooseSelect: _ctx.onSelectStatus,
                              dataSelect: 
                    !_ctx.accountIsForeign
                      ? _ctx.listStatusGoodsForIndonesian
                      : _ctx.listStatusGoodsForEnglish
                  ,
                              class: "w-full whitespace-no-wrap my-1.5 z-10",
                              isError: !_ctx.isSttForeign ? _ctx.errorMandatory[12] : false,
                              isDisabled: _ctx.isDisableDeliveryStatus,
                              disabledBackground: _ctx.isDisableDeliveryStatus
                            }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError", "isDisabled", "disabledBackground"]),
                            (!_ctx.isSttForeign && _ctx.errorMandatory[12])
                              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.shipmentStatus")), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_23, [
                          (!_ctx.isSttForeign)
                            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                                _createVNode("div", _hoisted_25, [
                                  _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.column.piecePerPack")), 1),
                                  _createVNode("div", _hoisted_26, [
                                    _createVNode("img", {
                                      onMouseenter: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = true)),
                                      onMouseleave: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = false)),
                                      src: 
                        _ctx.isOpenTooltipPiecePerPack
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      ,
                                      alt: ""
                                    }, null, 40, ["src"]),
                                    _withDirectives(_createVNode(_component_Tooltip, {
                                      title: "Piece Per Pack",
                                      message: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
                                      footer: "",
                                      style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                                    }, null, 512), [
                                      [_vShow, _ctx.isOpenTooltipPiecePerPack]
                                    ])
                                  ])
                                ]),
                                _createVNode(_component_lp_input, {
                                  modelValue: _ctx.manualBooking.sttPiecePerPack,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.manualBooking.sttPiecePerPack = $event)),
                                  format: _ctx.formatPiecePerPack,
                                  onChange: _ctx.checkFocus,
                                  placeholder: "Masukkan total koli per kemasan",
                                  error: _ctx.errorMandatory[13],
                                  errorCaption: 
                    _ctx.errorMandatory[13]
                      ? 'Total koli per kemasan wajib diisi'
                      : ''
                  ,
                                  disabled: _ctx.isDisableSTTPiecePerPack,
                                  disableBackground: _ctx.isDisableSTTPiecePerPack
                                }, null, 8, ["modelValue", "format", "onChange", "error", "errorCaption", "disabled", "disableBackground"])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isSttForeign)
                            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                _createVNode("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createVNode("div", _hoisted_30, [
                                    _createVNode("img", {
                                      onMouseenter: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = true)),
                                      onMouseleave: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = false)),
                                      src: 
                        _ctx.isOpenTooltipNextCommodity
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      ,
                                      alt: ""
                                    }, null, 40, ["src"]),
                                    _withDirectives(_createVNode(_component_Tooltip, {
                                      title: "Komoditas Selanjutnya",
                                      message: "Isi dengan komoditas barang yang ada dalam satu koli.",
                                      footer: "",
                                      style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                                    }, null, 512), [
                                      [_vShow, _ctx.isOpenTooltipNextCommodity]
                                    ])
                                  ])
                                ]),
                                _createVNode(_component_lp_input, {
                                  modelValue: _ctx.manualBooking.sttNextCommodity,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.manualBooking.sttNextCommodity = $event)),
                                  placeholder: "Masukan komoditas selanjutnya",
                                  onChange: _ctx.validateNextCommodity,
                                  error: _ctx.errorMandatory[14] || _ctx.error.nextCommodity,
                                  errorCaption: "Komoditas selanjutnya wajib diisi",
                                  onFocus: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setFieldIndex(14))),
                                  disabled: _ctx.isDisableNextCommodity,
                                  disableBackground: _ctx.isDisableNextCommodity
                                }, null, 8, ["modelValue", "onChange", "error", "disabled", "disableBackground"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isProductInterpack && _ctx.eligibleAdditionalInfo)
                    ? (_openBlock(), _createBlock("hr", _hoisted_31))
                    : _createCommentVNode("", true),
                  (_ctx.isProductInterpack && _ctx.eligibleAdditionalInfo)
                    ? (_openBlock(), _createBlock("div", _hoisted_32, [
                        _createVNode(_component_SectionAdditionalInfoInterpack, {
                          modelValue: _ctx.manualBooking,
                          "onUpdate:modelValue": [
                            _cache[27] || (_cache[27] = ($event: any) => (_ctx.manualBooking = $event)),
                            _ctx.setAdditionalInfo
                          ],
                          error: _ctx.errAditionalInfo,
                          "onUpdate:error": _cache[28] || (_cache[28] = ($event: any) => (_ctx.errAditionalInfo = $event)),
                          photos: _ctx.getAdditionalInfoPhotos
                        }, null, 8, ["modelValue", "error", "photos", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_33,
                  _createVNode("div", _hoisted_34, [
                    _createVNode(_component_Title, {
                      class: "flex pb-6",
                      label: "Berat barang",
                      fontSize: 16
                    }),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode("div", _hoisted_38, [
                          _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.grossWeight")) + " ", 1),
                          _hoisted_39,
                          _createVNode("div", _hoisted_40, [
                            _createVNode("img", {
                              onMouseenter: _cache[29] || (_cache[29] = ($event: any) => (_ctx.isOpenTooltipWeight = true)),
                              onMouseleave: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isOpenTooltipWeight = false)),
                              src: 
                        _ctx.isOpenTooltipWeight
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      ,
                              alt: "",
                              class: "ml-2"
                            }, null, 40, ["src"]),
                            _withDirectives(_createVNode(_component_Tooltip, {
                              title: _ctx.$t('bookingShipment.tooltip.weight'),
                              message: _ctx.$t('bookingShipment.tooltip.weightMsg'),
                              footer: "",
                              style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
                            }, null, 8, ["title", "message"]), [
                              [_vShow, _ctx.isOpenTooltipWeight]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_41, [
                          _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.dimensionsPackage")) + " ", 1),
                          _createVNode("span", _hoisted_42, " (" + _toDisplayString(_ctx.$t("bookingShipment.placeholder.dimensionsPackage")) + ")", 1)
                        ]),
                        _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("bookingShipment.column.dimensionWeight")), 1)
                      ]),
                      _createVNode("div", _hoisted_44, [
                        _hoisted_45,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index,
                            class: "flex flex-col py-6 border-b"
                          }, [
                            _createVNode("div", _hoisted_46, [
                              _createVNode("div", _hoisted_47, _toDisplayString(index + 1), 1),
                              _createVNode("div", _hoisted_48, [
                                _createVNode(_component_lp_input, {
                                  modelValue: key.grossWeight,
                                  "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), ($event: any) => (
                          _ctx.setOnValidationHws(key.grossWeight, index)
                        )],
                                  format: _ctx.formatFloat,
                                  onChange: _ctx.checkFocus,
                                  placeholder: "e.g 20",
                                  maxLength: _ctx.isMaxLengthGrossWeight,
                                  error: 
                          _ctx.errorEmbargo.weightStatus ||
                            _ctx.validateFullFilledWeight(key.grossWeight) ||
                            _ctx.validateEditWeightLoss('grossWeight')
                        ,
                                  errorCaption: 
                          _ctx.validateEditWeightLoss('grossWeight')
                            ? 'Perubahan penurunan berat tidak diijinkan'
                            : `Berat wajib diisi`
                        ,
                                  isErrorIconCaption: false,
                                  errorIcon: false,
                                  onFocus: _cache[31] || (_cache[31] = ($event: any) => (_ctx.setFieldIndex(17))),
                                  onOnClickViewDisabledInput: _ctx.onClickWeightAdjustment,
                                  disabled: 
                          _ctx.isDisablePieceDetail || _ctx.disabledWeightAdjustment
                        ,
                                  showViewDisabledInput: _ctx.disabledWeightAdjustment
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "onChange", "maxLength", "error", "errorCaption", "onOnClickViewDisabledInput", "disabled", "showViewDisabledInput"])
                              ]),
                              _createVNode("div", _hoisted_49, [
                                _createVNode(_component_InputDimension, {
                                  length: key.dimension.length,
                                  "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                                  width: key.dimension.width,
                                  "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                                  height: key.dimension.height,
                                  "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                                  onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                                  onChange: _ctx.checkFocus,
                                  error: 
                          _ctx.errorEmbargo.lengthStatus ||
                            _ctx.validateFullFilledVolume(key.volumeWeight) ||
                            _ctx.validateEditWeightLoss('volumeWeight')
                        ,
                                  errorCaption: 
                          _ctx.validateEditWeightLoss('volumeWeight')
                            ? 'Perubahan penurunan berat tidak diijinkan'
                            : _ctx.validateFullFilledVolume(key.volumeWeight)
                            ? 'Dimensi/paket wajib diisi'
                            : ''
                        ,
                                  withIcon: false,
                                  onOnClickViewDisabledInput: _ctx.onClickWeightAdjustment,
                                  disabled: 
                          _ctx.isDisablePieceDetail ||
                            key.isDimensionDisabled ||
                            _ctx.disabledWeightAdjustment
                        ,
                                  showViewDisabledInput: _ctx.disabledWeightAdjustment
                                }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "onChange", "error", "errorCaption", "onOnClickViewDisabledInput", "disabled", "showViewDisabledInput"])
                              ]),
                              _createVNode("div", _hoisted_50, _toDisplayString(_ctx.volumeWeight(key.volumeWeight)) + " Kg ", 1),
                              (_ctx.configRuleAdjustStt.config.adjustPieceRemove.rule == 'EDITABLE' || _ctx.ableToAddKgsByWhiteList)
                                ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                    _withDirectives(_createVNode("div", {
                                      onClick: ($event: any) => (_ctx.removeKGs(index)),
                                      class: "self-center cursor-pointer ml-3 relative"
                                    }, [
                                      _createVNode("div", {
                                        class: "img-close-icon",
                                        onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                                        onMouseleave: _cache[32] || (_cache[32] = ($event: any) => (_ctx.isHoverDelete = false))
                                      }, [
                                        _withDirectives(_createVNode(_component_Tooltip, {
                                          message: "Hapus Barang",
                                          title: "",
                                          footer: "",
                                          style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                                        }, null, 512), [
                                          [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                                        ])
                                      ], 40, ["onMouseenter"])
                                    ], 8, ["onClick"]), [
                                      [_vShow, _ctx.listKGsDefault.length < _ctx.listKGs.length]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (key.errorHws)
                              ? (_openBlock(), _createBlock("div", _hoisted_52, [
                                  _hoisted_53,
                                  _hoisted_54,
                                  _createVNode("p", _hoisted_55, " Berat mulai " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        (_ctx.showWarningHws)
                          ? (_openBlock(), _createBlock("div", _hoisted_56, [
                              _hoisted_57,
                              _createVNode("div", _hoisted_58, [
                                _createVNode(_component_Icons, {
                                  width: "16",
                                  height: "16",
                                  name: "announce",
                                  class: "mr-2"
                                }),
                                _hoisted_59,
                                _createTextVNode(" Berat diatas " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.errorMessageChWeight)
                      ? (_openBlock(), _createBlock("div", _hoisted_60, [
                          _hoisted_61,
                          (_ctx.isErrorMaxChWeightGoods || _ctx.isErrorMaxChWeightDimension)
                            ? (_openBlock(), _createBlock("span", _hoisted_62, " Total berat melebihi batas maksimum. Cek & atur ulang berat. "))
                            : (_openBlock(), _createBlock("span", _hoisted_63, " Berat kotor sudah melebihi batas berat, Anda tidak bisa ubah berat lagi. "))
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.configRuleAdjustStt.config.adjustPieceAdd.rule === 'EDITABLE') || (_ctx.isMaxAddKgs || _ctx.ableToAddKgsByWhiteList) )
                      ? (_openBlock(), _createBlock("div", _hoisted_64, [
                          ((_ctx.isMaxAddKgs || _ctx.configRuleAdjustStt.config.adjustPieceAdd.rule === 'EDITABLE') || _ctx.ableToAddKgsByWhiteList)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                onClick: _cache[33] || (_cache[33] = ($event: any) => (
                  _ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight || _ctx.disabledWeightAdjustment || _ctx.isMaxAddKgs || (_ctx.isErrorHws || _ctx.showWarningHws)
                    ? null
                    : _ctx.addKGs()
                )),
                                class: 
                  `flex gap-3 ${
                    _ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight || _ctx.disabledWeightAdjustment || _ctx.isMaxAddKgs || (_ctx.isErrorHws || _ctx.showWarningHws)
                      ? 'text-gray-lp-600 cursor-not-allowed'
                      : 'text-red-lp-300 cursor-pointer'
                  }`
                
                              }, [
                                _createVNode(_component_Icons, {
                                  name: "plus-circle",
                                  class: `${
                    _ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight || _ctx.disabledWeightAdjustment || _ctx.isMaxAddKgs || (_ctx.isErrorHws || _ctx.showWarningHws)
                      ? 'text-gray-lp-600'
                      : 'text-red-lp-300'
                  }`
                                }, null, 8, ["class"]),
                                _hoisted_65
                              ], 2))
                            : (_openBlock(), _createBlock("div", {
                                key: 1,
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight || _ctx.disabledWeightAdjustment || _ctx.isMaxAddKgs || (_ctx.isErrorHws || _ctx.showWarningHws)
                      ? null : _ctx.addKGs())),
                                class: 
                  `flex gap-3 ${
                    _ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight || _ctx.disabledWeightAdjustment || _ctx.isMaxAddKgs || (_ctx.isErrorHws || _ctx.showWarningHws)
                      ? 'text-gray-lp-600 cursor-not-allowed'
                      : 'text-red-lp-300 cursor-pointer'
                  }`
                
                              }, [
                                _createVNode(_component_Icons, {
                                  name: "plus-circle",
                                  class: 
                    `${
                      _ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight || _ctx.disabledWeightAdjustment || _ctx.isMaxAddKgs || (_ctx.isErrorHws || _ctx.showWarningHws)
                        ? 'text-gray-lp-600'
                        : 'text-red-lp-300'
                    }`
                  
                                }, null, 8, ["class"]),
                                _hoisted_66
                              ], 2))
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.onShowSectionAdjustmentWeight(
                  _ctx.manualBooking.sttShipmentId,
                  _ctx.manualBooking.sttNo
                )
              )
                      ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjustment, {
                          key: 2,
                          class: "mt-4",
                          ref: "section-weight-adjustment",
                          showViewAdjustment: _ctx.showViewAdjustment,
                          "onUpdate:showViewAdjustment": _cache[35] || (_cache[35] = ($event: any) => (_ctx.showViewAdjustment = $event)),
                          title: _ctx.$t('bookingV3.shipment.weightPieces.uploadWeightProofPhoto'),
                          watermark: _ctx.manualBooking.sttNo,
                          modelValue: _ctx.manualBooking.sttWeightAttachFiles,
                          onOnUploadImage: _ctx.upload,
                          onOnDeleteImage: _ctx.remove
                        }, null, 8, ["showViewAdjustment", "title", "watermark", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_67, [
                      _createVNode(_component_DataWrapper, {
                        fontSize: 14,
                        label: _ctx.$t('bookingShipment.column.selectServiceType'),
                        class: "w-full mr-4 mt-2"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isSttForeign)
                            ? (_openBlock(), _createBlock(_component_BannerProductType, {
                                key: 0,
                                class: "mt-3 mb-4"
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_product_poster, {
                            ref: "renderPoster",
                            productType: 
                    _ctx.manualBooking.sttProductTypeName.toLowerCase() ===
                    'jumbopackh2h'
                      ? 'jumbopack'
                      : _ctx.manualBooking.sttProductTypeName.toLowerCase()
                  ,
                            onChoseeProduct: _ctx.onSelectProduct,
                            onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
                            isOnePack: _ctx.isOnePack,
                            isJumboPack: !!_ctx.manualBooking.sttShipmentId,
                            isSameday: _ctx.showSameDay,
                            isFormForeign: _ctx.isSttForeign,
                            version: "v2",
                            isEdit: "",
                            hideKgs: "",
                            isDisabledProduct: _ctx.isDisabledProduct,
                            "booking-type": _ctx.formType
                          }, null, 8, ["productType", "onChoseeProduct", "onSetErrorTriggered", "isOnePack", "isJumboPack", "isSameday", "isFormForeign", "isDisabledProduct", "booking-type"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ])
                ])
              ])
            ])),
        (!_ctx.isError)
          ? (_openBlock(), _createBlock("div", _hoisted_68, [
              _createVNode(_component_SectionFooterBooking, {
                showCurrency: _ctx.visiblePrice || _ctx.shipmentC1Cod,
                isDisabled: _ctx.getIsDisableButton,
                payload: _ctx.payload,
                formType: _ctx.bookingType,
                isCodRetailApplied: _ctx.isCodRetailApplied,
                isVolumeWeight: _ctx.isVolumeWeight,
                isGrossWeight: _ctx.isGrossWeight,
                totalItem: _ctx.listKGs.length,
                totalGrossWeight: _ctx.totalGrossWeight,
                totalDimensionWeight: _ctx.totalVolumeWeight,
                chargeableWeight: 
          _ctx.isCampaign
            ? _ctx.totalCampaignChargeableWeight.toString().replace('.', ',')
            : _ctx.totalChargeableWeight
        ,
                onUpdateStatusErrorEmbargo: _ctx.updateStatusErrorEmbargo,
                onSetDiscount: _ctx.setDiscount,
                isCampaign: _ctx.isCampaign,
                goodsValue: _ctx.manualBooking.sttGoodsEstimatePrice,
                isSttForeign: _ctx.isSttForeign
              }, null, 8, ["showCurrency", "isDisabled", "payload", "formType", "isCodRetailApplied", "isVolumeWeight", "isGrossWeight", "totalItem", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "onUpdateStatusErrorEmbargo", "onSetDiscount", "isCampaign", "goodsValue", "isSttForeign"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.closeModalError,
          title: _ctx.titleErrorspesification,
          message: _ctx.errorCause,
          image: "image-modal-warning",
          textSuccess: "OK",
          class: "px-8"
        }, null, 8, ["onSubmit", "title", "message"]), [
          [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
        ]),
        (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 3,
              errorType: _ctx.errorCause,
              onCancel: _ctx.closeModalError,
              onTryAgain: _ctx.booking,
              modal: ""
            }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.onCloseSuccess,
          title: _ctx.$t('Perubahan Booking Berhasil !'),
          message: 
        `Detail STT “${_ctx.manualBooking.sttNo}” ${_ctx.$t(
          'bookingShipment.message.updated'
        )}.`
      ,
          image: "image-modal-success",
          textSuccess: "OK",
          class: "px-8"
        }, {
          custom: _withCtx(() => [
            (_ctx.discount.isDiscount)
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 0,
                  isShadow: false,
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode("h2", _hoisted_69, _toDisplayString(_ctx.$t("bookingShipment.error.totalPayment")), 1),
                    _createVNode("div", _hoisted_70, [
                      _createVNode("div", _hoisted_71, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalBeforeDiscount)), 1),
                      _createVNode("div", _hoisted_72, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit", "title", "message"]), [
          [_vShow, _ctx.openSuccess]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.handlerClose,
          onClose: _ctx.handlerCancelClose,
          title: _ctx.$t('Yakin Keluar Halaman?'),
          message: 
        _ctx.$t(
          'Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar dari halaman ini.'
        )
      ,
          image: "badge-confirmation-general",
          textSuccess: _ctx.$t('bookingShipment.action.buttonQuit'),
          textCancel: _ctx.$t('bookingShipment.action.buttonStay'),
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
          [_vShow, _ctx.isEditTerminated]
        ]),
        _createVNode(_component_ModalErrorNotAllowEdit, {
          "custom-path": _ctx.customPath,
          show: _ctx.isModalNotAllowEdit
        }, null, 8, ["custom-path", "show"])
      ], 64))
}